import { Autocomplete, Divider, Grid, TextField, useMediaQuery } from '@mui/material'
import React, { useContext, useEffect } from 'react'
import GlobalPageHeaderText from '../../utility/globalPageHeaderText'
import globalStyles from "../../../assets/styles/global.module.scss";
import styles from "../../../assets/styles/componentStyles/customApiStyles/customApiStyle.module.scss";
import dataConnectorStyles from "../../../assets/styles/componentStyles/dataconnector.module.scss";
import headerStyles from "../../../assets/styles/componentStyles/chatbotStyles/integrations.module.scss";
import GlobalButton from '../../utility/globalButton/button';
import AddIcon from '@mui/icons-material/Add';
import { Outlet, useNavigate, useSearchParams } from 'react-router-dom';
import { DataConnectorContext, DataConnectorContextpayload } from '../../../context/dataConnectorContext';
import { dataConnectorList } from '../../../models/axiosModel';
import { UserContext, UserContextPayload } from '../../../context/userContext';
import { hasCustomAPIPageManageAccess } from '../../../utils/constants';

const CustomApiGlobal = () => {

    const breakPoints = {
        smallScreen: useMediaQuery('(max-width : 600px) and (min-width : 0px)'),
        flagTabletScreen: useMediaQuery('(max-width : 900px) and (min-width : 600px)'),
    } 

    const navigate = useNavigate();

    const [searchParams, setSearchParams] = useSearchParams();
    let connector_id = searchParams.get("connector_id");
    const pathname = window.location.pathname?.toLowerCase();

    const { dataConnectorList } = useContext(DataConnectorContext) as DataConnectorContextpayload;
    const { apiRoutesPermissionAssignment, userDetail} = useContext(UserContext) as UserContextPayload;

    const handleListChange = (e: React.ChangeEvent<{}>, value: dataConnectorList) => {
        setSearchParams({ 'connector_id': (value.chatbot_data_connector_id).toString() });
    }

    const isCustomAPIListPage = () => {
        return pathname == "/customapi";
    }

    const renderMainHeadText = () => {
        if(isCustomAPIListPage()){
            return "Custom API";
        } else {
            if(connector_id && dataConnectorList){
                return (
                    <Grid item xs={9} lg={6}>
                        <Autocomplete
                            disableClearable
                            value={dataConnectorList?.find((list: dataConnectorList) => (list.chatbot_data_connector_id).toString() == connector_id)}
                            className={`${dataConnectorStyles.chatbotTitleSelect} ${globalStyles.globalHeaderFontSize} ${globalStyles.globalHeaderFontWeight}`}
                            options={dataConnectorList}
                            getOptionLabel={(option: dataConnectorList) => option.data_connector_functions?.data_connector_function_name}
                            onChange={(e, value) => handleListChange(e, value)}
                            renderInput={(params) => <TextField {...params} placeholder='Select' />}
                        />
                    </Grid>
                );
            } else {
                return "Create Custom API";
            }
        }
    }

    return (
        <>
            <Grid item xl={12} lg={12} md={12} sm={12} xs={12} className={`${globalStyles.fullwidth} ${headerStyles.templateWrapper}`}>
                <Grid container className={globalStyles.headerGlobalPaddingStyle} direction={"column"} flexWrap={"nowrap"}>
                    <Grid item xs={12} sm={12}>
                        <Grid container alignItems={"center"} direction={"column"}>
                            <Grid item className={`${globalStyles.fullwidth} ${globalStyles.headerTextContainerStyle}`}>
                                <GlobalPageHeaderText
                                    mainHeadText={renderMainHeadText()}
                                    flagMainTextOnly
                                    actionBlock={
                                        !(breakPoints.smallScreen) &&
                                        <Grid container gap={"12px"} justifyContent={(breakPoints.flagTabletScreen) ? "start" : "end"} flexWrap={"nowrap"}>
                                            {isCustomAPIListPage() && 
                                                dataConnectorList && dataConnectorList.length > 0 && hasCustomAPIPageManageAccess(apiRoutesPermissionAssignment, userDetail) &&
                                                <Grid item>
                                                    <GlobalButton
                                                        buttonText={"New Custom API"}
                                                        className='primaryButtonStyle'
                                                        startIcon={<AddIcon />}
                                                        sx={{ width: "190px" }}
                                                        onClick={() => navigate(`/customAPI/createCustomAPI`) }
                                                    />
                                                </Grid>
                                            }
                                        </Grid>
                                    }
                                />
                                {!(breakPoints.smallScreen) && <Divider className={`${globalStyles.fullwidth} ${globalStyles.dividerStyles} ${headerStyles.dividerStyle} ${styles.customAPIPageDivider}`} />}
                            </Grid>
                        </Grid>
                    </Grid>

                    <Outlet />
                </Grid>
            </Grid>
        </>
    )
}

export default CustomApiGlobal
